export const initialState = {
    filter: {
        firstName : null,
        surname: null,
        orderType : null,
        regionalId : null,
        initDate : null,
        endDate : null,
    },
    isFilter: false,
};

const filterMedicalExamReducer = (state= initialState, action) =>{
    switch (action.type) {
        case "SET_FILTER_MEDICAL_EXAM":
            return {
                ...state,
                filter: action.filter,
                isFilter: action.isFilter,
            }
    
        default:
            return state;
    }
}
export default filterMedicalExamReducer;